import { render, staticRenderFns } from "./CriadorTela.vue?vue&type=template&id=171a2bf7&scoped=true&"
import script from "./CriadorTela.vue?vue&type=script&lang=js&"
export * from "./CriadorTela.vue?vue&type=script&lang=js&"
import style0 from "./CriadorTela.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CriadorTela.vue?vue&type=style&index=1&id=171a2bf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a2bf7",
  null
  
)

export default component.exports